export default __webpack_public_path__ + "static/media/trampapo_02_31.d50f2142.jpg";